import type { CreditBalance } from '@/services/endpoints/credits';

export type DeriveCreditGateInput = {
  isFeatureUnavailable: boolean;
  isLoading: boolean;
  balance: CreditBalance | null;
  available: number;
};

export type DeriveCreditGateResult = {
  canUseFeature: boolean;
  isOutOfCredits: boolean;
  isFeatureUnavailable: boolean;
};

/**
 * Shared credit feature gate:
 * - 503 → feature off: skip balance checks, allow actions
 * - loading → block until settled
 * - empty / no balance row → block
 * - available <= 0 → block (reserved ignored)
 * - available > 0 → allow
 */
export const deriveCreditGate = ({
  isFeatureUnavailable,
  isLoading,
  balance,
  available,
}: DeriveCreditGateInput): DeriveCreditGateResult => {
  if (isFeatureUnavailable) {
    return {
      canUseFeature: true,
      isOutOfCredits: false,
      isFeatureUnavailable: true,
    };
  }

  if (isLoading) {
    return {
      canUseFeature: false,
      isOutOfCredits: false,
      isFeatureUnavailable: false,
    };
  }

  const canUseFeature = balance != null && available > 0;

  return {
    canUseFeature,
    isOutOfCredits: !canUseFeature,
    isFeatureUnavailable: false,
  };
};
